<template>
  <el-col :span="3" class="payments">
    <div :class="payments.class">{{ payments.text }}</div>
    <div
      :class="['payments__comment', { filled: highlightComment }]"
      @click="$emit('edit-comment')"
    >
      Коммент
    </div>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FlightPayment',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    highlightComment: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getFlights: 'responses/getFlightById',
      getLoading: 'responses/getLoading',
    }),
    flight() {
      return this.getFlights(this.id)
    },
    payments() {
      return this.flight.bid.is_paid
        ? { class: 'paid', text: 'ОПЛАЧЕНО' }
        : { class: 'unpaid', text: 'не оплачено' }
    },
    loading() {
      return this.getLoading('Pay')
    },
  },
}
</script>

<style lang="sass">
.flight-item
  .payments
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    gap: 6px
    .paid
      font-weight: bold
      color: #00BF4E
    .unpaid
      color: red
    &__comment
      font-size: 14px
      font-weight: 500
      color: #98A9BC
      text-decoration: underline
      cursor: pointer
      &.filled
        color: #67C23A
        &:hover
          color: #85ce61
</style>
